import * as types from "./types";
import _ from "lodash";
import { LOGOUT } from "../iam/types";

export const defaultState = {
  circles: {},
  loading: false,
  errors: [],
  saving: false,
  sending_order: false,
  inviting_friends: false,
  marking_interest: false,
  migrating_members: false
};

const my_circles = (state = defaultState, action) => {
  switch (action.type) {
    case types.MIGRATING_MEMBERS_ERROR:
    case types.MIGRATING_MEMBERS:
      return {
        ...state,
        migrating_members: action.loading
      };
    case types.REQUESTING_PUZZLE:
    case types.SEND_PUZZLE_REQUEST:
      return {
        ...state,
        sending_order: action.loading
      };
    case types.REQUESTING_CIRCLE:
    case types.REQUESTED_CIRCLE:
    case types.FETCHING_MY_CIRCLES:
    case types.MARKING_PRODUCT_AS_BOUGHT:
    case types.MARKED_PRODUCT_AS_BOUGHT:
      return {
        ...state,
        loading: action.loading
      };
    case types.FETCHED_MY_CIRCLES:
      const new_circles = _.keyBy(action.circles, "guid");
      return {
        ...state,
        circles: { ...state.circles, ...new_circles },
        loading: action.loading
      };
    case types.ERROR_FETCHING_MY_CIRCLES:
    case types.ERROR_MARKING_CIRCLES:
    case types.ERROR_REQUESTING_CIRCLE:
      return {
        ...state,
        errors: [...state.errors, action.error],
        loading: action.loading
      };
    case types.SAVED_CIRCLE_DETAILS:
      let existent_circles = { ...state.circles };
      existent_circles[action.circle.guid] = action.circle;
      return {
        ...state,
        circles: existent_circles,
        saving: action.loading
      };
    case types.SAVING_CIRCLE_DETAILS:
      return {
        ...state,
        saving: action.loading
      };
    case types.ERROR_SAVING_CIRCLE:
      return {
        ...state,
        errors: [...state.errors, action.error],
        saving: action.loading
      };
    case types.ERROR_REQUESTING_PUZZLE:
      return {
        ...state,
        errors: [...state.errors, action.error],
        sending_order: action.loading
      };
    case types.INVITED_FRIENDS:
    case types.INVITING_FRIENDS:
      return {
        ...state,
        inviting_friends: action.loading
      };
    case types.ERROR_INVITING_FRIENDS:
      return {
        ...state,
        errors: [...state.errors, action.error],
        inviting_friends: action.loading
      };
    case types.MARKED_INTEREST:
    case types.MARKING_INTEREST:
      return {
        ...state,
        marking_interest: action.loading
      };
    case types.ERROR_MARKING_INTEREST:
      return {
        ...state,
        errors: [...state.errors, action.error],
        marking_interest: action.loading
      };
      
    case LOGOUT:
      return defaultState;
    default:
      return state;
  }
};
export default my_circles;
